module.exports = __webpack_public_path__ + "img/twitterLoginImgNew.fead7c28.svg";